<!--
* @FileDescription: 正则表达式相关
* @Author: Rocky
* @Date: 2020-07-14
* @LastEditors: Rocky
* @LastEditTime: 2020-07-14
-->
<script>
const list = {
  'username': /^[a-zA-Z0-9_-]{4,16}$/, // 4-16位，可包含大小写字母数字_-
  'password': /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/,
  'email': /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
  'phone': /^1[34578]\d{9}$/,
  'idcard': /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  'int': /^-?\d+$/, // 整数，正数 /^\d+$/，负数 /^-\d+$/
  'num': /^-?\d*\.?\d+$/, // 数字，正 /^\d*\.?\d+$/，负 /^-\d*\.?\d+$/
  'ip': /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  'date': /^(?:(?!0000)[0-9]{4}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[0-9]{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[13579][26])00)-02-29)$/,
  'has_chinese': /^[\u4E00-\u9FA5]$/
}

const msg = {
  'username': '请输入正确的用户名格式',
  'password': '密码至少包括1个大写字母，1个小写字母，1个数字，1个特殊字符',
  'email': '请输入正确的邮箱格式',
  'phone': '请输入正确的手机号码',
  'idcard': '请输入正确的身份证号',
  'int': '请输入整数',
  'num': '请输入数字',
  'ip': '请输入正确的IP地址',
  'date': '请输入正确的日期格式',
  'has_chinese': '请输入中文字符'
}

export default {
  list, msg
}
</script>



// WEBPACK FOOTER //
// src/components/toolkits/regExpHelper.vue